<template>
  <div>
    <div
      class="btn-wrapper d-flex justify-content-md-end justify-content-center"
    >
      <button
        class="btn btn-outline-primary wizard-btn prev-btn"
        @click="previous"
      >
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
        {{ $t("global.return") }}
      </button>
      <button class="btn btn-primary wizard-btn next-btn" @click="nextStep">
        {{ $t("global.save") }}
      </button>
    </div>
    <div class="card card-small mb-4 mt-3">
      <div class="card-body">
        <div class="py-2 px-3">
          <h5 class="mb-4">{{ $t("days.off.request.step.five.title") }}</h5>
          <div class="row">
            <div class="col-lg-6">
              <div v-if="request.isExternalClient" class="row">
                  <div v-if="request.firstName" class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29" height="40.04" viewBox="0 0 32.29 40.04">
                            <defs>
                              <clipPath id="clip-path">
                                <path id="Path_111" data-name="Path 111" d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z" transform="translate(-2528 -583.5)" fill="#303778"/>
                              </clipPath>
                              <clipPath id="clip-path-2">
                                <rect id="Rectangle_204" data-name="Rectangle 204" width="731.907" height="480.475" fill="#303778"/>
                              </clipPath>
                            </defs>
                            <g id="Group_745" data-name="Group 745" clip-path="url(#clip-path)">
                              <g id="Group_744" data-name="Group 744" transform="translate(-566.869 -132.859)">
                                <g id="Group_743" data-name="Group 743" transform="translate(0 0)" clip-path="url(#clip-path-2)">
                                  <rect id="Rectangle_203" data-name="Rectangle 203" width="41.259" height="49.14" transform="translate(562.384 128.309)" fill="#303778"/>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.first.name") }}</p>
                          <span>{{ request.firstName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="request.lastName" class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29" height="40.04" viewBox="0 0 32.29 40.04">
                            <defs>
                              <clipPath id="clip-path">
                                <path id="Path_111" data-name="Path 111" d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z" transform="translate(-2528 -583.5)" fill="#303778"/>
                              </clipPath>
                              <clipPath id="clip-path-2">
                                <rect id="Rectangle_204" data-name="Rectangle 204" width="731.907" height="480.475" fill="#303778"/>
                              </clipPath>
                            </defs>
                            <g id="Group_745" data-name="Group 745" clip-path="url(#clip-path)">
                              <g id="Group_744" data-name="Group 744" transform="translate(-566.869 -132.859)">
                                <g id="Group_743" data-name="Group 743" transform="translate(0 0)" clip-path="url(#clip-path-2)">
                                  <rect id="Rectangle_203" data-name="Rectangle 203" width="41.259" height="49.14" transform="translate(562.384 128.309)" fill="#303778"/>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.last.name") }}</p>
                          <span>{{ request.lastName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>


              </div>
              <div v-if="request.isExternalClient" class="row">
                  <div v-if="request.email" class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29" height="40.04" viewBox="0 0 32.29 40.04">
                            <defs>
                              <clipPath id="clip-path">
                                <path id="Path_111" data-name="Path 111" d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z" transform="translate(-2528 -583.5)" fill="#303778"/>
                              </clipPath>
                              <clipPath id="clip-path-2">
                                <rect id="Rectangle_204" data-name="Rectangle 204" width="731.907" height="480.475" fill="#303778"/>
                              </clipPath>
                            </defs>
                            <g id="Group_745" data-name="Group 745" clip-path="url(#clip-path)">
                              <g id="Group_744" data-name="Group 744" transform="translate(-566.869 -132.859)">
                                <g id="Group_743" data-name="Group 743" transform="translate(0 0)" clip-path="url(#clip-path-2)">
                                  <rect id="Rectangle_203" data-name="Rectangle 203" width="41.259" height="49.14" transform="translate(562.384 128.309)" fill="#303778"/>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.email") }}</p>
                          <span>{{ request.email }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="request.destination" class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29" height="40.04" viewBox="0 0 32.29 40.04">
                            <defs>
                              <clipPath id="clip-path">
                                <path id="Path_111" data-name="Path 111" d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z" transform="translate(-2528 -583.5)" fill="#303778"/>
                              </clipPath>
                              <clipPath id="clip-path-2">
                                <rect id="Rectangle_204" data-name="Rectangle 204" width="731.907" height="480.475" fill="#303778"/>
                              </clipPath>
                            </defs>
                            <g id="Group_745" data-name="Group 745" clip-path="url(#clip-path)">
                              <g id="Group_744" data-name="Group 744" transform="translate(-566.869 -132.859)">
                                <g id="Group_743" data-name="Group 743" transform="translate(0 0)" clip-path="url(#clip-path-2)">
                                  <rect id="Rectangle_203" data-name="Rectangle 203" width="41.259" height="49.14" transform="translate(562.384 128.309)" fill="#303778"/>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.destination") }}</p>
                          <span>{{ request.destination }}</span>
                        </div>
                      </div>
                    </div>
                  </div>


              </div>
              <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg
                            width="44px"
                            height="44px"
                            viewBox="0 0 44 44"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                            <title>Iconspace_Calendar</title>
                            <desc>Created with Sketch.</desc>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Antarmuka_One-Color-UI-element-1"
                                transform="translate(-338.000000, -242.000000)"
                              >
                                <g
                                  id="Iconspace_Calendar"
                                  transform="translate(336.000000, 240.000000)"
                                >
                                  <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                                  <path
                                    d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                    id="Shape"
                                    fill="#303778"
                                    fill-rule="nonzero"
                                  />
                                  <polygon
                                    id="Shape"
                                    fill="#303778"
                                    points="10 18 18 18 18 26 10 26"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.from") }}</p>
                          <span>{{ formatDate(request.fromDate) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg
                            width="44px"
                            height="44px"
                            viewBox="0 0 44 44"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                            <title>Iconspace_Calendar</title>
                            <desc>Created with Sketch.</desc>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Antarmuka_One-Color-UI-element-1"
                                transform="translate(-338.000000, -242.000000)"
                              >
                                <g
                                  id="Iconspace_Calendar"
                                  transform="translate(336.000000, 240.000000)"
                                >
                                  <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                                  <path
                                    d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                    id="Shape"
                                    fill="#303778"
                                    fill-rule="nonzero"
                                  />
                                  <polygon
                                    id="Shape"
                                    fill="#303778"
                                    points="10 18 18 18 18 26 10 26"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.to") }}</p>
                          <span>{{ formatDate(request.toDate) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>


              </div>
              <div class="row">
                  <div class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg
                            width="44px"
                            height="44px"
                            viewBox="0 0 44 44"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                            <title>Iconspace_Calendar</title>
                            <desc>Created with Sketch.</desc>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Antarmuka_One-Color-UI-element-1"
                                transform="translate(-338.000000, -242.000000)"
                              >
                                <g
                                  id="Iconspace_Calendar"
                                  transform="translate(336.000000, 240.000000)"
                                >
                                  <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                                  <path
                                    d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                    id="Shape"
                                    fill="#303778"
                                    fill-rule="nonzero"
                                  />
                                  <polygon
                                    id="Shape"
                                    fill="#303778"
                                    points="10 18 18 18 18 26 10 26"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.starting.hour") }}</p>
                          <span>{{ formatTime(request.fromDate) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg
                            width="44px"
                            height="44px"
                            viewBox="0 0 44 44"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                            <title>Iconspace_Calendar</title>
                            <desc>Created with Sketch.</desc>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Antarmuka_One-Color-UI-element-1"
                                transform="translate(-338.000000, -242.000000)"
                              >
                                <g
                                  id="Iconspace_Calendar"
                                  transform="translate(336.000000, 240.000000)"
                                >
                                  <polygon id="Shape" points="0 0 48 0 48 48 0 48" />
                                  <path
                                    d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                    id="Shape"
                                    fill="#303778"
                                    fill-rule="nonzero"
                                  />
                                  <polygon
                                    id="Shape"
                                    fill="#303778"
                                    points="10 18 18 18 18 26 10 26"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.ending.hour") }}</p>
                          <span>{{ formatTime(request.toDate) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>


              </div>
                <div v-if="!request.isExternalClient" class="row">
                  <div v-if="request.destination" class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29" height="40.04" viewBox="0 0 32.29 40.04">
                            <defs>
                              <clipPath id="clip-path">
                                <path id="Path_111" data-name="Path 111" d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z" transform="translate(-2528 -583.5)" fill="#303778"/>
                              </clipPath>
                              <clipPath id="clip-path-2">
                                <rect id="Rectangle_204" data-name="Rectangle 204" width="731.907" height="480.475" fill="#303778"/>
                              </clipPath>
                            </defs>
                            <g id="Group_745" data-name="Group 745" clip-path="url(#clip-path)">
                              <g id="Group_744" data-name="Group 744" transform="translate(-566.869 -132.859)">
                                <g id="Group_743" data-name="Group 743" transform="translate(0 0)" clip-path="url(#clip-path-2)">
                                  <rect id="Rectangle_203" data-name="Rectangle 203" width="41.259" height="49.14" transform="translate(562.384 128.309)" fill="#303778"/>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div class="">
                          <p>{{ $t("minibus.request.step.three.destination") }}</p>
                          <span>{{ request.destination }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>

            </div>
            <div class="col-lg-6">
              <div>
                <div>
                  <h6 style="font-weight: 600">{{ $t("minibus.request.step.three.reason") }} :</h6>
                  <span>{{ request.title }}</span>
                </div>
                <div>
                  <h6 style="font-weight: 600">{{ $t("minibus.request.step.three.description") }} : </h6>
                  <span>{{ request.description }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeUtils from '../../../utils/TimeUtils';
import Long from "long";

export default {
  name: 'StepFourMinibus',
  props: ['user', 'request'],
  methods: {
    formatDate(date) {
      return TimeUtils.formatDate(Long.fromValue(new Date(date).getTime()));
    },
    formatTime(date) {
      return TimeUtils.formatTime(Long.fromValue(new Date(date).getTime()));
    },
    previous() {
      this.$emit('input', null);
    },
    nextStep() {
      this.$emit('input', true);
    },
  },
};
</script>

<style lang="scss">
.underline {
  text-decoration: underline;
}
.five {
  p {
    margin: 0;
  }
  .d-flex {
    padding: 1rem;
    align-content: center;
    align-items: center;
  }
}
.card {
  position: relative;
  background-color: transparent;
}
.wizard-btn-wrapper {
  position: absolute;
  top: -120px;
  right: 0;
}
</style>
